<template>
  <div class="user-list">
    <el-button style="margin-bottom: 20px" type="primary" @click="exportScoreDetail">下载填写记录</el-button>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="uuid" label="姓名">
          <template v-if="scope.row.user" slot-scope="scope">
            {{ scope.row.user.real_name || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>

        <el-table-column prop="create_time" label="填写时间"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="showRecordDetail(scope.row)">查看/打分</el-button>

            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-drawer title="填写记录" :visible.sync="rightBox" direction="rtl">
      <div class="list">
        <div v-for="item in subject" class="item">
          <div class="title">
            <p>
              问题{{ item.exam_index }}：<b>{{ item.title }}</b>
            </p>
            <span>得分{{ item.receiver.score || 0 }}分</span>
          </div>
          <div v-if="item.type != 3" class="options">
            <div v-for="(mi, key) in item.option">{{ key }}：{{ mi }}</div>

            <div>
              学生答案：<span v-if="Array.isArray(item.receiver.correct)">{{ item.receiver.correct.join(",") }}</span>
            </div>
            <div>
              正确答案：<span v-for="mi in item.correct">{{ mi }}</span>
            </div>
          </div>
          <div v-else class="score">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <label for="" style="white-space: nowrap">学生答案：</label>
              <div v-if="Array.isArray(item.receiver.correct)" class="media-box" style="flex: 1; word-break: break-all">
                <img
                  v-for="(mi, index) in item.imgs"
                  v-if="Array.isArray(item.imgs) && item.imgs.length > 0"
                  width="90%"
                  :src="mi"
                />
                <video
                  v-for="(mi, index) in item.videos"
                  v-if="Array.isArray(item.videos) && item.videos.length > 0"
                  width="90%"
                  :src="mi"
                  controls="controls"
                ></video>
                <span v-if="Array.isArray(item.texts) && item.texts.length > 0" style="max-width: 50%">{{
                  item.receiver.correct.join(",")
                }}</span>
              </div>

              <el-input v-model="item.nscore" placeholder="打分" style="width: 100px"></el-input>
            </div>
            <div style="text-align: center; padding: 10px 0">
              <el-button type="primary" @click="subScore(item)">确定提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="终考评分表" :visible.sync="lastScoreBox" width="30%" center>
      <el-form ref="lastForm" :model="lastForm" :rules="lastRule" label-width="100px" class="demo-ruleForm">
        <el-form-item label="个人品质" prop="title">
          <el-input v-model="lastForm.title"></el-input>
        </el-form-item>
        <el-form-item label="课堂纪律" prop="title">
          <el-input v-model="lastForm.title"></el-input>
        </el-form-item>
        <el-form-item label="行为举止" prop="title">
          <el-input v-model="lastForm.title"></el-input>
        </el-form-item>
        <el-form-item label="实操成绩" prop="title">
          <el-input v-model="lastForm.title"></el-input>
        </el-form-item>
        <el-form-item label-width="0" style="text-align: center">
          <el-button type="primary" @click="vowBox = true">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="日常考试评分表" :visible.sync="dailyBox" width="30%" center>
      <el-form ref="dailyForm" :model="dailyForm" :rules="dailyRule" label-width="100px" class="demo-ruleForm">
        <el-form-item label="完成项目数" prop="title">
          <el-input v-model="dailyForm.title"></el-input>
        </el-form-item>
        <el-form-item label="评分" prop="title">
          <el-input v-model="dailyForm.title"></el-input>
        </el-form-item>
        <el-form-item label="评分老师" prop="title">
          <el-input v-model="dailyForm.title"></el-input>
        </el-form-item>

        <el-form-item label-width="0" style="text-align: center">
          <el-button type="primary" @click="dailyBox = false">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="打分宣誓" :visible.sync="vowBox" width="30%" center>
      <div>
        为确保考试打分公平公正,请打分老师在打分前上传宣誓视频. 宣誓内容如下:本人xxx,保证打分公平公正…….
        <imgUploads v-model="video" media-type="1"> </imgUploads>
        <el-button type="primary" @click="vowBox = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { TotalScore, TotalScoreDetail, delScoreDetail, exportScoreDetail, onlineScore } from "@/api/edu.js";

import { mixin } from "@/mixins/pagination.js";
import imgUploads from "@/components/pub/supperUpload.vue";
export default {
  components: {
    imgUploads,
  },
  mixins: [mixin],
  data() {
    return {
      score: "",
      rightBox: false,
      subject: [],
      vowBox: false,
      video: "",
      lastScoreBox: false,
      lastForm: {},
      lastRule: {},
      dailyForm: {},
      dailyRule: {},
      dailyBox: false,
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
      },
      tableData: [],
      actrow: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    subScore(item) {
      onlineScore({ score: item.nscore }, item.receiver.uuid).then((res) => {
        if (res) {
          item.nscore = "";
          this.$message.success("成功");
          this.showRecordDetail(this.actrow);
        }
      });
    },
    showRecordDetail(row) {
      this.actrow = row;
      TotalScoreDetail(row.uuid).then((res) => {
        if (res) {
          res.subject.sort((a, b) => {
            return a.exam_index - b.exam_index;
          });
          const video = ["mp4", "flv"];
          const img = ["png", "jpg", "jpeg"];
          this.subject = res.subject.map((it) => {
            it.imgs = [];
            it.videos = [];
            it.texts = [];
            const list = it.receiver ? it.receiver.correct : "";
            if (list instanceof Array) {
              list.forEach((mi) => {
                const substr = mi.split(".");
                const last = substr[substr.length - 1];
                if (video.indexOf(last.toLowerCase()) >= 0) {
                  it.videos.push(mi);
                } else if (img.indexOf(last.toLowerCase()) >= 0) {
                  it.imgs.push(mi);
                } else {
                  it.texts.push(mi);
                }
              });
            }
            return {
              ...it,
            };
          });
          this.rightBox = true;
        }
      });
    },
    toAdd() {
      console.log(row);
      this.$router.push({
        path: "/offline-detail",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-add",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    deleteItem(row) {
      this.$confirm("确定要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delScoreDetail(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    exportScoreDetail() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        paper_uuid: this.$route.query.uuid,
      };
      exportScoreDetail(param);
    },
    async getList() {
      const param = {
        ...this.searchParam,
        paper_uuid: this.$route.query.uuid,
        page_index: this.page_index,
        page_size: this.page_size,
      };
      console.log(param);
      this.loading = true;
      const res = await TotalScore(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.list {
  padding: 0 20px;
  max-height: 80vh;
  overflow: auto;
  .item {
    margin: 10px 0;
    border-bottom: 1px solid #eee;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999;
    b {
      color: #333;
    }
    span {
      font-size: 20px;
      color: #333;
      white-space: nowrap;
    }
  }
}
</style>
